/** Ідентифікатори вкладок «Етапи» й панелі під ними (WAI-ARIA tabs: вкладка → aria-controls панелі, панель → aria-labelledby вкладки). */

/** Безпечна частина id зі значення (пробіли, лапки й інші символи — `_` з кодом). */
const safe = (value: string): string => encodeURIComponent(value).replace(/[%.']/g, '_');

/** id вкладки етапу `value` типу `rtKey`. */
export function stageTabId(rtKey: string, value: string): string {
  return `stages-${safe(rtKey)}-tab-${safe(value)}`;
}

/** id панелі таблиці під вкладками етапів типу `rtKey`. */
export function stagePanelId(rtKey: string): string {
  return `stages-${safe(rtKey)}-panel`;
}
